import { ApiTypeEnum, HTTP_STATUS_BAD_REQUEST } from "../../../constants";
import * as ApiAdapterUtils from '../../../../apiAdapter/utils';
/**
 * The character service returns 400 on these endpoints for exactly one case: the condition was
 * already applied (or already removed) by another app, such as Maps. That's recoverable, so the
 * condition saga handlers deal with it, and the error is kept away from the app-level error screen.
 */
const CONDITION_REQUEST_CONFIG = {
    managedErrorStatuses: [HTTP_STATUS_BAD_REQUEST],
};
/**
 * Updates a character's condition.
 */
export const putCharacterCondition = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'condition', CONDITION_REQUEST_CONFIG);
/**
 * Deletes a character's condition.
 */
export const deleteCharacterCondition = ApiAdapterUtils.makeDelete(ApiTypeEnum.CHARACTER_SERVICE, 'condition', CONDITION_REQUEST_CONFIG);
